import { SectionLoaderComponent } from './section-loader.component';

export const SectionLoaderModule = angular
  .module('sfMobile.components.section-loader', [
    'sfMobile.components.section-skeleton',
    'sfMobile.components.button-more',
    'sfMobile.components.badge-beta',
  ])
  .component('sfSectionLoader', SectionLoaderComponent).name;
